import GameTransactions from '../components/GameTransactions';

const GameTransactionsPage = () => {
	return <GameTransactions />;
};

export default GameTransactionsPage;
